import loadable from '@/utils/loadable';

export const HomePage = loadable(() => import('@/pages/Home'));
export const SportsPage = loadable(() => import('@/pages/Sports'));
export const FavouritesPage = loadable(() => import('@/pages/Favourites'));
export const EventDetailsPage = loadable(() => import('@/pages/EventDetails'));
export const CasinoPage = loadable(() => import('@/pages/Casino'));
export const CasinoPlaygroundPage = loadable(() => import('@/pages/CasinoPlayground'));

// Account
export const ProfilePage = loadable(() => import('@/pages/Profile'));
export const DepositPage = loadable(() => import('@/pages/Deposit'));
export const WithdrawPage = loadable(() => import('@/pages/Withdraw'));
export const AccountStatementPage = loadable(() => import('@/pages/AccountStatement'));
export const DepositReportPage = loadable(() => import('@/pages/DepositReport'));
export const WithdrawReportPage = loadable(() => import('@/pages/WithdrawReport'));
export const ProfitLossReportPage = loadable(() => import('@/pages/ProfitLossReport'));
export const BetListReportPage = loadable(() => import('@/pages/BetListReport'));
export const BonusReportPage = loadable(() => import('@/pages/BonusReport'));
export const ReferralPage = loadable(() => import('@/pages/Referral'));
export const UserPage = loadable(() => import('@/pages/User'));
export const RulesPage = loadable(() => import('@/pages/Rules'));

// 404
// export const NotFoundPage = loadable(() => import('@/pages/NotFound'));